import React from "react";
import { salmon } from "../../theme";

const NoView = () => {
  return (
    <div
      className='mt-2'
      style={{
        textAlign: 'center',
        animation: 'pulse-white 2s infinite'
      }}
    >
      <i
        className='fa fa-times-circle-o'
        style={{
          fontSize: '128px',
          color: salmon[500]
        }}
      />
      <div style={{ fontSize: '32px' }}>
        You do not have permission to view
      </div>
    </div>
  );
};

export default NoView;
